import React from 'react';
import cn from 'classnames';
import { wpToCF } from '../../utils/data/cdn';
import styles from './styles.module.css';

interface Props {
  title: string;
  subTitle?: string;
  image: string;
  excerpt: string;
  link: string;
  className?: string;
}

const Excerpt = ({
  className,
  title,
  subTitle,
  image,
  excerpt,
  link
}: Props) => {
  const style = {
    backgroundImage: `url('${wpToCF(image)}')`
  };
  return (
    <div
      className={cn(
        'bg-abn-gray-light sm:p-4 sm:grid grid-cols-7 gap-4 mb-4',
        styles.excerpt,
        className
      )}
    >
      <div className='col-span-2'>
        <a href={link}>
          <div className={`bg-center bg-cover ${styles.image}`} style={style} />
        </a>
      </div>
      <div className='relative m-4 sm:m-0 flex flex-col col-span-5'>
        <h2 className='flex-shrink-0 text-abn-red uppercase font-bold text-l pb-1'>
          <a href={link} dangerouslySetInnerHTML={{ __html: title }}></a>
        </h2>
        {subTitle && <p className='text-xs mb-2'>{subTitle}</p>}
        <p>{excerpt}</p>
        <p className='mb-4 sm:mb-0'>
          <a href={link} className='text-abn-red'>
            Read more →
          </a>
        </p>
      </div>
    </div>
  );
};

export default Excerpt;
